import { TimeSlot } from "@clipboard-health/contract-worker-app-bff";
import { type Theme } from "@mui/material";

export function getGradientByShiftPeriod(shiftPeriod: TimeSlot, theme: Theme) {
  switch (shiftPeriod) {
    case TimeSlot.AM: {
      return theme.palette.shift?.day.gradient;
    }

    case TimeSlot.PM: {
      return theme.palette.shift?.evening.gradient;
    }

    case TimeSlot.NOC: {
      return theme.palette.shift?.overnight.gradient;
    }

    default: {
      return undefined;
    }
  }
}
